export default "__VITE_ASSET__CEqDOtYF__"